<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="headingContanten">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseContanten" aria-expanded="false" aria-controls="collapseContanten">
                Contanten
            </button>
        </h2>
        <div id="collapseContanten" class="accordion-collapse collapse" aria-labelledby="headingContanten"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Schenkingen in contanten zijn volledig belastbaar tenzij een vrijstelling van toepassing is. Voor
                fiscale doeleinden moet de overdracht aantoonbaar zijn, bijvoorbeeld door een bankafschrift of
                schriftelijke vastlegging.
                <div class="space20"></div>
                Bij grotere bedragen is het aan te raden de schenking via een notariële akte
                of schriftelijke overeenkomst te formaliseren om discussies met de Belastingdienst te voorkomen. Voor
                schenkingen binnen het gezin kan een onderhandse akte voldoende zijn.
            </div>
        </div>
    </div>
</div>
